import type { ITableDef } from '../core/types';

/**
 * Table 01: "The Basics"
 *
 * Designed for iPhone portrait (roughly 1:2 aspect ratio)
 * - 3 sequential targets (A → B → C)
 * - 2 flippers at the bottom
 * - 1 central hole (hazard)
 * - Finish gate at top center
 *
 * Layout (top-down view, 5 wide x 10 tall):
 *
 *     +-------------+
 *     |   [FINISH]  |  z = -4.5
 *     |             |
 *     |  [C]        |  z = -2.5
 *     |             |
 *     |      (O)    |  z = -0.5 (hole)
 *     |             |
 *     |  [B]   [A]  |  z = 1.5
 *     |             |
 *     |             |
 *     |  /--\--\    |  z = 4.3 (flippers at drain)
 *     +-+       +---+
 *       | DRAIN |      z = 5
 *
 */
export const TABLE_01: ITableDef = {
  id: 'table-01',
  name: 'The Basics',

  width: 5,
  length: 10,

  spawnPosition: { x: 0, y: 0.3, z: 2 },
  finishPosition: { x: 0, y: 0, z: -4.5 },

  targets: [
    {
      id: 'A',
      position: { x: 1.2, y: 0.15, z: 1.5 },
    },
    {
      id: 'B',
      position: { x: -1.2, y: 0.15, z: 1.5 },
    },
    {
      id: 'C',
      position: { x: -1, y: 0.15, z: -2.5 },
    },
  ],

  holes: [
    {
      id: 'center-hole',
      position: { x: 0.3, y: 0, z: -0.5 },
      radius: 0.35,
    },
  ],

  walls: [],

  flippers: [
    {
      id: 'left-flipper',
      position: { x: -1.4, y: 0.1, z: 4.0 },
      side: 'right',
      length: 1.2,
    },
    {
      id: 'right-flipper',
      position: { x: 1.4, y: 0.1, z: 4.0 },
      side: 'left',
      length: 1.2,
    },
  ],

  medalTimes: {
    gold: 12,
    silver: 20,
    bronze: 35,
  },

  theme: {
    boardColor: '#34495e', // Soft slate blue
    wallColor: '#5d6d7e',  // Muted blue-grey
    accentColor: '#f1c40f', // Soft gold
  },
};
